import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=3d966627"
import script from "./Acompanhamento.vue?vue&type=script&lang=js"
export * from "./Acompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports